import React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, Button
} from "@material-ui/core";
import t from "../../languages/pl";

const useStyles = theme => ({
    dialogActions: {
        display: 'flex',
        justifyContent: "flex-end",
        alignItems: "center"
    },
    checkbox: {
        color: "grey"
    },
    formControl: {
        marginLeft: theme.spacing(1)
    },
    backdrop: {
        background: "rgba(255,255,255,0.7)",
        backdropFilter: "blur(1px)"
    }
});

const WelcomeDialog = props => {
    const { classes, open, onClose, data } = props;
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="sm"
            style={{ zIndex: 2001 }}
            BackdropProps={{
                classes: { root: classes.backdrop }
            }}
        >
            <DialogTitle>
                {data.tytul}
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1">
                    {data.tresc}
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                >
                    {t.close}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

WelcomeDialog.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default withStyles(useStyles)(WelcomeDialog);
